<template>
	<div class="circle-container">
		<div class="circle-menu">
			<chat-custom menuType="2" chooseFirst 
				@custom-call="customCall($event)" 
				@chat-custom-call="chatCustomCall($event)"
				key="circle-home-custom">
			</chat-custom>
		</div>
		<div class="circle-box">
			<div class="circle-header">
				<div class="circle-header-title">
					<p>{{custom.wx_name}}<span>-{{custom.identity == null ? '': custom.identity}}</span>的朋友圈</p>
				</div>
				<div class="circle-header-tools">
					<span class="circle-header-t-reload" @click="reload" title="重载朋友圈"></span>
					<span class="circle-header-t-me" :class="{'circle-header-t-me-active':onlySeeMyself}" :title="onlySeeMyself ? '查看所有' : '只看自己'" @click="SeeMyself"></span>
					<span class="circle-header-t-read" style="border: none;" @click="get_no_read" title="获取未读评论"></span>
				</div>
			</div>
			<div class="circle-content">
				<div class="circle-list">
					<div class="circle-list-wrap">
						<circle-custom-moment :custom="custom" ref="ChildCircleCustomMoment" v-show="onlySeeMyself"></circle-custom-moment>
						<chat-moment :momentType="2" :custom="custom" :no_read="no_read" ref="CircleHomeMoment" key="CircleHomeMoment" v-show="!onlySeeMyself"></chat-moment>
					</div>
				</div>
				<div class="circle-sender">
					<circle-sender 
						@choose-temp-call="chooseTempCall($event)"
						@choose-Auth-call = "chooseAuthCall($event)"
						@choose-remind-call = "chooseRemindCall($event)"
						@choose-position-call="choosePositionCall($event)"
						:authFans = "authFans"
						:circleTempData="circleTemp"
						:remindFans = "remindFans"
						:customList="customList"
						:position="position">
					</circle-sender>
				</div>
			</div>
		</div>
		<div class="circle-options" v-if="optinsOpen">
			<component
			 :is="currentOpt"
			 :customId="customId"
			 @fans-auth-call="fansAuthCall($event)"
			 @circle-temp-select = "circleTempSelect($event)"
			 @fans-remind-call = "fansRemindCall($event)"
			 @map-call="mapCall($event)"
			 @close-circle-temp="close"
			 @close-circle-auth="close"
			 @close-circle-remind="close">
			</component>
		</div>
	</div>
</template>

<script>
	import ChatCustom from "../../components/ChatCustom.vue"
	import ChatMoment from "../../components/ChatMoment.vue"
	import CircleCustomMoment from "./CircleCustomMoment.vue"
	import CircleSender from "./CircleSender.vue"
	import CircleTemplate from "./CircleTemplate.vue"
	import CircleAuth from "./CircleAuth.vue"
	import CircleRemind from "./CircleRemind.vue"
	import PositionComp from "../../components/PositionComp.vue"
	
	export default{
		name: 'CircleHome',
		data(){
			return{
				custom:{},
				customList:[],
				currentOpt: 'CircleRemind',
				optinsOpen: false,
				circleTemp: {},
				customId:0,
				authFans:{
					type:1,
					list:[]
				},
				remindFans:[],
				onlySeeMyself: false,
				position:{
					lat: 0,
					lng: 0,
					title: '未选择',
					address: '',
					qq_map: ''
				},
				no_read: 1
			}
		},
		components:{
			ChatCustom,
			ChatMoment,
			CircleSender,
			CircleTemplate,
			CircleAuth,
			CircleRemind,
			CircleCustomMoment,
			PositionComp
		},
		methods:{
			// 重新请求朋友圈
			reload(){
				if(this.onlySeeMyself){
					this.$refs.ChildCircleCustomMoment.refresh()
				}else{
					this.$refs.CircleHomeMoment.refresh()
				}
				CHAT_LAYER.msg('刷新成功，请稍后，不要频繁刷新',{icon:7})
			},
			
			// 客服点击回调
			customCall(data){
				this.custom = data
			},
			
			// 客服列表请求完成后，所有客服的数据回调
			chatCustomCall(data){
				this.customList = data
			},
			
			// 回调监听-发送页面-选择朋友圈模板按钮点击
			chooseTempCall(){
				this.currentOpt = "CircleTemplate"
				this.optinsOpen = !this.optinsOpen
			},
			
			// 回调监听-发送页面-选择给谁看按钮点击
			chooseAuthCall(customId){
				this.currentOpt = "CircleAuth"
				this.customId = customId
				this.optinsOpen = !this.optinsOpen
			},
			
			// 回调监听-发送页面-选择@谁按钮点击
			chooseRemindCall(customId){
				this.currentOpt = "CircleRemind"
				this.customId = customId
				this.optinsOpen = !this.optinsOpen
			},
			
			// 回调监听-发送页面-选择位置点击回调
			choosePositionCall(){
				this.currentOpt = "PositionComp"
				this.optinsOpen = !this.optinsOpen
			},
			
			// 回调监听-朋友圈发送页面点开的页面-点关闭按钮
			close(){
				this.optinsOpen = false
			},
			
			// 回调监听-朋友圈模板页面-数据选择
			circleTempSelect(data){
				this.circleTemp = data
				this.optinsOpen = false
			},
			
			// 回调监听-给谁看选择回调
			fansAuthCall(data){
				this.authFans = data
				this.optinsOpen = false
			},
			
			// 回调监听-提醒谁看选择回调
			fansRemindCall(data){
				this.remindFans = data
				this.optinsOpen = false
			},
			
			// 回调监听-位置选择选择回调
			mapCall(data){
				this.position = data
				this.optinsOpen = false
			},
			
			// 只看自己切换
			SeeMyself(){
				this.onlySeeMyself = !this.onlySeeMyself
			},
			
			// 获取未读评论
			get_no_read(){
				this.no_read = (new Date()).getTime()
			}
		}
	}
</script>

<style>
	.circle-container{
		position: relative;
		width: 100%;
		height: 100%;
		user-select: none;
	}
	.circle-container .circle-menu{
		width: 80px;
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		overflow: hidden;
		background-color: #27354a;
	}
	.circle-container .circle-box{
		position: absolute;
		top: 0;
		left: 80px;
		bottom: 0;
		right: 0;
		overflow: hidden;
	}
	.circle-box .circle-header{
		padding: 0 20px;
		height: 50px;
		line-height: 50px;
		border-bottom: 1px solid #CCCCCC;
		display: flex;
		justify-content: flex-start;
	}
	.circle-header .circle-header-title{
		color: #42B983;
		font-size: 14px;
		font-weight: 600;
	}
	.circle-header-title span{
		color: #d23131;
	}
	.circle-header .circle-header-tools{
		margin-left: 8px;
	}
	.circle-header-tools span{
		height: 20px;
		width: 20px;
		display: inline-block;
		vertical-align: middle;
		margin: 0 8px;
		background-position: center;
		background-size: 16px auto;
		background-repeat: no-repeat;
		border: 1px solid #CCCCCC;
		border-radius: 50%;
		cursor: pointer;
	}
	.circle-header-tools .circle-header-t-reload{
		background-size: 14px 14px !important;
		background-image: url(../../assets/img/comp-m-reload.png);
	}
	.circle-header-tools .circle-header-t-me{
		background-image: url(../../assets/img/eye-normal.png);
		background-size: 18px auto;
	}
	.circle-header-tools .circle-header-t-me-active{
		background-image: url(../../assets/img/eye-active.png);
		border: 1px solid #42B983;
	}
	.circle-header-tools .circle-header-t-read{
		background-size: 22px auto !important;
		background-image: url(../../assets/img/comp-m-no-read.png);
	}
	.circle-box .circle-content{
		position: absolute;
		top: 51px;
		left: 0;
		bottom: 0;
		right: 0;
		overflow: hidden;
		display: flex;
		justify-content: space-between;
		flex-wrap: nowrap;
	}
	.circle-box .circle-list,.circle-box .circle-sender{
		width: 50%;
		height: 100%;
		overflow: hidden;
	}
	.circle-box .circle-list{
		border-right: 1px solid #CCCCCC;
		box-sizing: border-box;
	}
	.circle-list .circle-list-wrap{
		position: relative;
		width: 100%;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
		box-sizing: border-box;
	}
	.circle-options{
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #000000a1;
		padding: 50px 100px;
	}
</style>
